import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import urlToId from "../../../../../helpers/UrlToId";
import client from "../../../../../helpers/Client";
import AppointmentSelect from "../../../../../components/select/AppointmentSelect";
import SaveButton from "../../../../../components/buttons/SaveButton";

export default function CreateAppointmentModal({ task, revalidator, state, onClose }) {
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [date, setDate] = useState(null);
  const [errors, setErrors] = useState({});
  const toast = useToast();
  const setTime = (start, end) => {
    setStartTime(start);
    setEndTime(end);
  };
  const handleSubmit = () => {
    const taskId = urlToId(task.url);
    client
      .post(`/tasks/${taskId}/set_appointment/`, {
        appointment_date: date,
        appointment_start_time: startTime,
        appointment_end_time: endTime,
      })
      .then(async () => {
        onClose()
        toast({
          title: "Başarılı",
          description: task.appointment_date
            ? "Randevu güncellendi."
            : "Randevu oluşturuldu.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });

        revalidator.revalidate();
      })
      .catch(async (error) => {
        if (error.response) {
          setErrors(error.response.data);
        }
      });
  };

  useEffect(() => {
    setStartTime(null);
    setEndTime(null);
    setDate(null);
    setErrors({});
  }, [state.isOpen]);

  return (
    <Modal isOpen={state.isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {task?.appointment_date ? "Randevu Güncelle" : "Randevu Ayarla"}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <AppointmentSelect
            DateOnChange={(e) => setDate(e.target.value)}
            TimeOnChange={(e) => setTime(...e.target.value.split("-"))}
            errors={errors}
          />
          {errors.non_field_errors &&
            errors.non_field_errors.map((e) => (
              <Text key={e} color="red">
                {e}
              </Text>
            ))}
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose}>
            Vazgeç
          </Button>
          <SaveButton onClick={handleSubmit}>Kaydet</SaveButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
